import { MANUFACTURING, MANUFACTURING_PRODUCTION, SUSTAINABILITY_ATTRIBUTES } from "../constants/attributesByGroups";
import { ATTRS_LOCAL_LOGOS } from "../constants/attrsLocalLogos";

export const ATTRS_TO_ASSING_LOCAL_LOGOS = ["epd", "oekoTex", "alternativePolymer"];

const certificateFileString = "CertificateFile"

export const addLocalLogo = (key, groups, locale) => {
  groups.map((group) => {
    if (SUSTAINABILITY_ATTRIBUTES[group.title.key].hasOwnProperty(key)) {
      group.attrs.filter((property) => {
        if (property.title === key) {
          property.logoImg = ATTRS_LOCAL_LOGOS[key][locale];
        }
      });
    }
  });
}

export const addAttrsInGeneral = (groups, packagingFsc, key, value) => {
  let keyCondition =
    !key.includes(certificateFileString) &&
    !key.includes("Not") &&
    key !== "id" &&
    key !== "__typename";

  if (keyCondition) {
    groups.map((group, index) => {
      if (
        SUSTAINABILITY_ATTRIBUTES[group.title.key].hasOwnProperty(key) &&
        value !== null &&
        value !== "" &&
        value !== false
      ) {
        if (!key.includes("Logo")) {
          group.attrs.push({
            id: `item-${key}-${index}`,
            title: key,
            value: value,
            certificate: "",
          });
        }

        if (
          key === SUSTAINABILITY_ATTRIBUTES["packaging"].packagingFscLogo &&
          packagingFsc
        ) {
          group.attrs.push({
            id: `item-${key}-${index}`,
            title: key,
            value: value,
            certificate: "",
          });
        }
      }
    });
  }
};

export const addAttrsLogos = (groups, key, value, locale) => {
  // Add local logo to assing local logos
  if (ATTRS_TO_ASSING_LOCAL_LOGOS.includes(key))
    addLocalLogo(key, groups, locale);

  if (key.includes("Logo")) {
    groups.map((group) => {
      if (SUSTAINABILITY_ATTRIBUTES[group.title.key].hasOwnProperty(key)) {
        group.attrs.filter((property) => {
          if (key.includes(property.title)) {
            property.logoImg = value;
          }
        });
      }
    });
  }
};

export const addCertificates = (groups, key, value) => {
  const expiresString = "Expires"
  const notExpiresString = "Not"

  // Add certificate value to the current attribute
  if (key.includes(certificateFileString) && !key.includes(expiresString)) {
    groups.map((group) => {
      if (SUSTAINABILITY_ATTRIBUTES[group.title.key].hasOwnProperty(key)) {
        group.attrs.filter((property) => {
          if (key.includes(property.title)) {
            property.certificate = value;
          }
        });
      }
    });
  }

  // Add expire certificate value to the current attribute
  if (key.includes(expiresString) && !key.includes(notExpiresString)) {
    groups.map((group) => {
      if (SUSTAINABILITY_ATTRIBUTES[group.title.key].hasOwnProperty(key)) {
        group.attrs.filter((property) => {
          if (key.includes(property.title)) {
            property.certificateExpiresDate = value;
          }
        });
      }
    });
  }

  // Add NOT expire certificate value to the current attribute
  if (!key.includes(certificateFileString) && key.includes(notExpiresString)) {
    groups.map((group) => {
      if (SUSTAINABILITY_ATTRIBUTES[group.title.key].hasOwnProperty(key)) {
        group.attrs.filter((property) => {
          if (key.includes(property.title)) {
            property.certificateNotExpires = value;
          }
        });
      }
    });
  }
};

export const addManufacturingCertifications = (
  sustainabilityGroups,
  manufacturingCertifications
) => {
  manufacturingCertifications.forEach((property) => {
    const groupKey = property.isSustainable
      ? MANUFACTURING
      : MANUFACTURING_PRODUCTION;

    const group = sustainabilityGroups.find(
      (group) => group.title.key === groupKey
    );

    if (!group) return;

    group.attrs.push({
      id: property.id,
      title: property.name,
      logoImg: property.logo,
      certificate: property.certificate,
      certificateExpiresDate: property.fileExpires,
      certificateNotExpires: property.fileNotExpires,
    });
  });
};